module.exports = __webpack_public_path__ + "static/media/product3@2x.1c789db7.png";